export const typeFilterKeys = ["Manuscript", "Print"];

export const dimensionFilterKeys = [
    "S",
    "L",
    "M",
    "XL",
    "XXL",
    "Sumo"
];

export const languageFilterKeys = ["Turkish", "Arabic"];

export const scriptFilterKeys = [
    "Nesihle",
    "Talikle",
    "Rika",
    "Divani",
    "Küçük boy",
    "Nestalikle",
];

// Ottoman Keywords
export const genreFilterKeys = [
    "‘Acâ’ib",
    "‘Acâibnâme",
    "‘Avd",
    "‘İbret-nümâ",
    "A‘lâm (sing. Âlem)",
    "A‘vân",
    "Acâ’ib al-Arz va’l-Buldân",
    "Acâ’ib al-Mahlükât; ‘Acâ’ib al-Mahlûkât",
    "Afrika",
    "Ahbâr",
    "âhval",
    "Ahval; Ahvâl",
    "al-İşârât",
    "Amelî",
    "Amerika",
    "Amsâr",
    "Arazî",
    "Arz",
    "Askeri",
    "Asya",
    "Atlas",
    "Atlaslı Coğrafya",
    "Avrupa",
    "Beyân",
    "Bilâd",
    "Ceb",
    "Cevelan",
    "Cihan",
    "Cihannümâ",
    "Coğrafya",
    "Coğrafya Muallimi",
    "Dağ",
    "Dalil; Dalîl",
    "Demiryolu",
    "Deniz Kitabı",
    "Derya",
    "Dirâsat",
    "Dîvân",
    "Esmâ-i Bilâd",
    "Fenn",
    "Fenni",
    "Fezleke",
    "Garâ’ib",
    "Garâ’ib al-Mavcüdât",
    "Güzergah",
    "Harita hocası",
    "Harita; Harîta",
    "Haritalar",
    "Hey’et",
    "Hikâyât",
    "Hikemî",
    "Hıtây-nâme",
    "Hulâsa",
    "İklîm-nâme",
    "İktisad",
    "ilm",
    "İstatistik",
    "Îstatistikî",
    "İsti‘lâm",
    "Kabartma harita",
    "Kadîm",
    "Kânun",
    "Kitâb; Kitab",
    "Kısm",
    "Kıtaât-ı Hamse",
    "Kroki",
    "Küçük Coğrafya",
    "Küre-i Arz",
    "Lâyiha",
    "Lügat",
    "Ma‘rifat",
    "Macmü’at",
    "Madhal",
    "Malûmât",
    "Mamâlik",
    "Manâsik al-Masâlik",
    "Manâzil",
    "Manazir",
    "Mebâdi",
    "Memâlik-i Mahrüsa-ı Şâhâne",
    "Memâlik-i Osmaniye",
    "Menzilnâme",
    "Merâhil",
    "Mesafe",
    "Millî",
    "Mir'at-ül Coğrafya",
    "Mir’ât",
    "Mir’ât al-Kâinât",
    "Mücmel",
    "Mufassal",
    "Mufradat",
    "Muhît",
    "Muhtasar",
    "Mukaddime",
    "Mükemmel",
    "Mülahhas",
    "Münşaât",
    "Musahabe",
    "Musavver",
    "Mutâlaât",
    "Müzekkire",
    "Nazari",
    "Okyanusya",
    "Ordu",
    "Orta",
    "Osmânî",
    "Osmaniye",
    "Ravzat",
    "Rehber",
    "Rehnümâ",
    "Resimli",
    "Rihla",
    "Risale; Risâla",
    "Rivâyât",
    "Sefaretnâme; Sefaret-nâme; Sefâretnâme",
    "Sefer",
    "Şekilli",
    "Seyahat",
    "Seyahatname",
    "Sira",
    "Sualli ve Cevaplı",
    "Ta’rif ve Evsafı",
    "Tahdit",
    "Tahsîl",
    "Taksim",
    "Talhîs; Telhıs",
    "Tarcamat",
    "Târîfât",
    "Tarih",
    "Tastîh",
    "Tazkirat",
    "Tedkîkât",
    "Tedris",
    "Terceme",
    "Tersim",
    "Tıbbî",
    "Topografya",
    "Tuhfat",
    "Umûmî",
    "Umûmî Atlas",
    "Usûl",
    "Vatanî",
    "Vilayet",
    "Yazısız Harita Defteri",
    "Yeni",
    "Yürüyüş",
    "Zamân",
    "Ziraat",
    "Ziyârât",
    "Zubdat",
];

// Table columns being searched by
export const searchKeys = [
    "authorNameOriginal",
    "authorNameTranslit",
    "titleOriginal",
    "titleTranslit",
    "language",
    "genre",
    "textType",
    "date",
];

export const defaultDateValues = [0, 2000];

export const defaultDimensionValues = [0, 100];
